export default __webpack_public_path__ + "static/media/img02.54bad2c8.svg";